import { createSelector } from 'reselect';

import { REAL_DEVICE_CLOUD, VIRTUAL_DEVICE_CLOUD } from './constants';
import { selectors as filterBarSelectors } from './../filterBar';
import { selectors as usersSelectors } from './../users';

const containerSelector = createSelector([
  (store) => store.apps.jobs,
  (store, props) => props.match.params.username,
  (store, props) => props.isOpenSauceUser,
  (store) => store.user,
  (store, props) => props.isSubaccountDashboard,
  filterBarSelectors.selectFilterSelection,
  filterBarSelectors.selectJSDateRange,
  (store) => filterBarSelectors.selectIsFiltered(
    store,
    usersSelectors.selectUser(store).user_id,
  ),
],
(
  jobs,
  username,
  isOpenSauceUser,
  user,
  isSubaccountDashboard,
  filterSelection,
  dateRange,
  isFiltered,
) => ({
  automatedLoading: jobs.flatJobs.get('automatedLoading'),
  filters: jobs.filters,
  filtersInitialized: jobs.filters.get('filtersInitialized'),
  isOpenSauceUser: isOpenSauceUser || !user.isAuthenticated(),
  jobsTeamSharingFeatureEnabled: !isOpenSauceUser,
  jobsTeamSharingEnabled: jobs.users.get('user').organization.settings ?
    jobs.users.get('user').organization.settings.jobs_cross_team_sharing :
    true,
  organizationId: jobs.users.get('user').organization.id || user.organization.id,
  orgTeams: jobs.filters.get('orgTeams'),
  orgUsers: jobs.filters.get('orgUsers'),
  page: jobs.flatJobs.get('page'),
  perPage: jobs.flatJobs.get('perPage'),
  rdcOffset: jobs.flatJobs.get('rdcOffset'),
  shouldFetchOrgUsers: !isOpenSauceUser && !isSubaccountDashboard && user.isAuthenticated(),
  user: jobs.users.get('user'),
  username: username || jobs.users.get('user').username,

  // Selected filter values
  // NOTE: Map rdc|vdc -> real_device_cloud and virtual_device_cloud for compatibility
  cloudType: filterSelection.environment === 'rdc' ? REAL_DEVICE_CLOUD : VIRTUAL_DEVICE_CLOUD,
  isFiltered,
  statuses: filterSelection.statuses,
  owner: filterSelection.owner,
  searchQuery: filterSelection.search,
  selectedBrowsers: filterSelection.browsers,
  selectedBuilds: filterSelection.builds,
  selectedDevices: filterSelection.devices,
  selectedEnvironment: filterSelection.environment,
  selectedPlatforms: filterSelection.platforms,
  selectedDateRange: dateRange,
  selectedTags: filterSelection.tags,
}));

const automatedJobsSelector = createSelector([
  (store) => store.apps.jobs,
  (store) => store.user,
  filterBarSelectors.selectFilterSelection,
],
(jobs, user, filterSelection) => ({
  automated: jobs.flatJobs.get('automated'),
  automatedLoading: jobs.flatJobs.get('automatedLoading'),
  automatedStates: jobs.flatJobs.get('runningStates'),
  isPerformanceEnabled: user.get('performance_enabled'),
  rdc: jobs.flatJobs.get('rdc'),
  rdcLoading: jobs.flatJobs.get('rdcLoading'),
  rdcMoreAvailable: jobs.flatJobs.get('rdcMoreAvailable'),
  selectedTags: (
    filterSelection.environment ?
      filterSelection.tags[filterSelection.environment] :
      []
  ),
  showTags: (
    filterSelection.environment &&
    filterSelection.tags[filterSelection.environment].length > 0
  ),
  totalJobs: jobs.flatJobs.get('totalJobs'),
}));

const userSelector = (store) => store.apps.jobs.users.user;

export default containerSelector;
export { automatedJobsSelector, containerSelector, userSelector };
